import Reveal from './Reveal.jsx';
import { TESTIMONIALS } from '../data/site.js';

export default function Testimonials() {
  return (
    <section className="testimonials">
      <div className="container">
        <Reveal className="section-header">
          <div className="section-label tl-label">Patient Stories</div>
          <h2 className="section-title tl-title">What Our Patients Say</h2>
          <p className="section-desc tl-desc">
            Real words from patients who trust Kanaga Dental Clinic with their smiles.
          </p>
        </Reveal>
        <div className="tl-grid">
          {TESTIMONIALS.map((t, i) => (
            <Reveal className="tl-card" key={t.name} delay={i * 80}>
              <div className="tl-stars" aria-label="5 out of 5 stars">
                ★★★★★
              </div>
              <p>&ldquo;{t.quote}&rdquo;</p>
              <div className="tl-author">
                <div className="tl-avatar">{t.initials}</div>
                <div className="tl-info">
                  <h4>{t.name}</h4>
                  <span>{t.role}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
